import type React from 'react'
import { CoverOverview, SeparatorLine } from './styled'
import { Cover } from './cover'
import { CoverInformation } from './cover-info'
import type { CoverInformationProps } from './interface'

export const ProductCoverInformation: React.FC<CoverInformationProps> = ({
  coverInformation,
  productMetaData,
  tagLine,
}) => {
  return (
    <CoverOverview>
      <Cover productMetadata={productMetaData} tagLine={tagLine} />
      <SeparatorLine />
      <CoverInformation coverInformation={coverInformation} />
    </CoverOverview>
  )
}
